export const uniqueTestCaseTableColumns: any = [
  {
    key: "checkbox",
    display_name: "",
    headerStyles: {
      background: "#7593F2",
      width: "5%",
      borderRadius: "6px 0 0",
    },
    _config: {
      type: "checkbox-conditional",
      displayInColumn: false,
      isConditionalCheck: true,
      conditionalCheck: { key: "level", value: 0 },
    },
  },
  {
    display_name: "#",
    key: "sno",
    headerStyles: {
      background: "#7593F2",
      width: "6%",
      color: "#ffffff",
    },
  },
  {
    display_name: "Test Case ID",
    key: "testId",
    headerStyles: {
      background: "#7593F2",
      color: "#ffffff",
      width: "12%",
    },
  },
  {
    display_name: "Test Case Name",
    key: "testName",
    headerStyles: {
      background: "#7593F2",
      width: "20%",
      color: "#ffffff",
    },
  },
  {
    display_name: "Test Case Description",
    key: "description",
    headerStyles: {
      background: "#7593F2",
      color: "#ffffff",
      width: "27%",
    },
  },
  {
    display_name: "Expected Results",
    key: "cleanedExpResult",
    headerStyles: {
      borderRadius: "0 6px 0 0",
      background: "#7593F2",
      color: "#ffffff",
      width: "30%",
    },
  },
];